module.exports = __webpack_public_path__ + "img/icon-plstudent-logo.4714b9e1.png";